import { Component, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { News } from './news.types';
import { NewsService } from '../../services/http/news.service';
import { timer } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@UntilDestroy()
@Component({
  selector: 'hk-news',
  templateUrl: 'news.component.html',
  host: { class: 'flex flex-1 flex-col min-h-full' },
})
export class NewsComponent implements OnInit {
  private readonly refreshInterval = 300_000; // 5 minutes

  currentNewsItem?: News;
  currentNewsItemIndex = 0;
  news: News[] = [];
  isLoading = false;
  error: string | undefined;

  constructor(private newsService: NewsService) {}

  ngOnInit(): void {
    this.setupNewsSubscription();
  }

  private setupNewsSubscription(): void {
    timer(0, this.refreshInterval)
      .pipe(
        untilDestroyed(this),
        switchMap(() => this.newsService.fetchNews()),
      )
      .subscribe({
        next: (news) => this.updateNews(news),
      });
  }

  refreshNews(): void {
    this.isLoading = true;
    this.error = undefined;

    this.newsService
      .fetchNews()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: (news) => this.updateNews(news),
      });
  }

  changeNews(index: number) {
    if (this.news.length === 0) return;

    if (index >= this.news.length) {
      index = 0;
    } else if (index < 0) {
      index = this.news.length - 1;
    }

    this.currentNewsItem = this.news[index];
    this.currentNewsItemIndex = index;
  }

  private updateNews(news: News[]): void {
    this.news = news;
    if (news.length > 0) {
      this.currentNewsItemIndex = Math.min(this.currentNewsItemIndex, news.length - 1);
      this.currentNewsItem = news[this.currentNewsItemIndex];
    } else {
      this.currentNewsItem = undefined;
      this.currentNewsItemIndex = 0;
    }
    this.isLoading = false;
  }
}
